import { useState } from 'react';
import { PageHeader } from '@/components/ui';
import { Tabs, TabList, TabTrigger, TabContent } from '@/components/ui/Tabs';
import { PageContainer } from '@/components/layout';
import { SlackSettingsTab } from '@/components/admin-settings/SlackSettingsTab';
import { FabricSettingsTab } from '@/components/admin-settings/FabricSettingsTab';
import { AuditConfigTab } from '@/components/admin-settings/AuditConfigTab';

type SettingsTab = 'slack' | 'fabric' | 'audit';

export function AdminSettingsPage() {
  const [activeTab, setActiveTab] = useState<SettingsTab>('slack');

  return (
    <PageContainer variant="narrow" className="space-y-6">
      <PageHeader
        title="Admin Settings"
        subtitle="Slack, Fabric, and audit configuration in one place."
      />

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabList>
          <TabTrigger value="slack">Slack Settings</TabTrigger>
          <TabTrigger value="fabric">Fabric Settings</TabTrigger>
          <TabTrigger value="audit">Audit Configuration</TabTrigger>
        </TabList>

        <TabContent value="slack">
          <SlackSettingsTab />
        </TabContent>

        <TabContent value="fabric">
          <FabricSettingsTab />
        </TabContent>

        <TabContent value="audit">
          <AuditConfigTab />
        </TabContent>
      </Tabs>
    </PageContainer>
  );
}
